// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/style/index.less'
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import store from './store/'
import Clickoutside from './directive/clickoutside'
import hhkjsq from '@/common/hhkjsq.js'
// import {statistics} from '@/utils/index'
const {appInfo, app} = hhkjsq

Vue.config.productionTip = false

import {Spinner, TabContainer, TabContainerItem, Swipe, SwipeItem} from 'mint-ui'
Vue.component(Spinner.name, Spinner)
Vue.component(TabContainer.name, TabContainer)
Vue.component(TabContainerItem.name, TabContainerItem)
Vue.component(Swipe.name, Swipe)
Vue.component(SwipeItem.name, SwipeItem)

Vue.directive('clickoutside', Clickoutside)
if (appInfo) {
  // app中等到jsbridge注册完毕后初始化页面
  document.addEventListener('ChangJSBridgeReady', function () {
    init()
    app.hideMoreMenu()
    // 埋点
    // statistics('View')
  })
} else {
  init()
}

/* eslint-disable no-new */
function init () {
  new Vue({
    el: '#app',
    store,
    template: '<App/>',
    components: { App }
  })
}



// WEBPACK FOOTER //
// ./src/main.js